import {I18nGlobals} from "../translation/i18nInterface";

export const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';

export interface AnnotationProperties extends I18nGlobals {
	width: string | number;
	height: string | number;
	viewBox?: string;
	points?: Array<{ x: number, y: number }>
	stroke?: number;
	borderColor?: string;
	color?: string;
	fontColor?: string;
	fontSize?: number;
	opacity?: number;
	rotation?: number;
	date?: string;
	onMoveStart?: (event: any) => void;
	onContextMenu?: (event: any) => void;
	onClick?: (event: any) => void;
}